import React, { useEffect } from 'react';

declare global {
  interface Window {
    Trustpilot: any;
  }
}

window.Trustpilot = window.Trustpilot || {};

const TrustBox: React.FC = () => {
  const ref = React.useRef(null);
  useEffect(() => {
    const aScript = document.createElement('script');
    aScript.type = 'text/javascript';
    aScript.src = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js';
    aScript.async = true;
    document.head.appendChild(aScript);
    aScript.onload = function () {
      window.Trustpilot.loadFromElement(ref.current, true);
    };
    return () => {
      document.head.removeChild(aScript);
    };
  }, []);
  return (
    <div
      ref={ref}
      className='trustpilot-widget'
      data-locale='nl-NL'
      data-template-id='5406e65db0d04a09e042d5fc'
      data-businessunit-id='51ee7b850000640005602baa'
      data-style-height='28px'
      data-style-width='100%'
      data-theme='light'
    >
      <a href='[https://nl.trustpilot.com/review/schoonenberg.nl]' target='_blank' rel='noopener'>
        Trustpilot
      </a>
    </div>
  );
};
TrustBox.displayName = 'TrustBox';

export default TrustBox;
